
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";

export const FossilsPark=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Salkhan Fossils Park</h1>
           <p className="sub-heading">Asia's oldest and Over 150 Crore years old fossils park</p>
         </div>
         <div className="description">
         Salkhan Fossils Park, officially known as Sonbhadra Fossils Park, is a fossil park in Uttar Pradesh, India. It is located 12 km from Robertsganj, near Salkhan village on state highway SH5A in Sonbhadra district. The fossils in the park are estimated to be nearly 1400 million years old.The fossils found in the Sonbhadra Fossils Park are algae and stromatolites types of fossils. The park is spread over an area of about 25 hectares in Kaimur Range, adjacent to Kaimur Wildlife Sanctuary. It comes under jurisdiction of the State forest department.Geologists have been aware of the fossils found in the present-day park area since the 1930s. People who have carried out research in the area include Mr. Auden (1933), Mr. Mathur (1958 and 1965), and Professor S. Kumar (1980–81). On 23 August 2001. Subsequently, it was formally inaugurated as a fossil park by District Magistrate Bhagawan Shankar on 8 August 2002.An international workshop was organised in December 2002, attracting participation from 42 delegates from India and abroad. Canadian geologist H.J. Hoffman was impressed by the fossils, and remarked that he had not seen such beautiful and clear fossils anywhere else in the world.[2] In 2004, research Mukund Sharma further explored the area </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Fossils Park/fossils1.jpeg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Fossils Park/fossils2.jpeg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Fossils Park/fossils3.jpeg')}
               alt="Mukha Fall 3"
               className="gallery-image"
             />
             {/* <p className="image-caption">The lush green surroundings of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Fossils Park/fossils4.jpeg')}
               alt="Mukha Fall 4"
               className="gallery-image"
             />
             {/* <p className="image-caption">The tranquil ambiance at sunset.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Fossils Park/fossils5.jpeg')}
               alt="Mukha Fall 5"
               className="gallery-image"
             />
             {/* <p className="image-caption">A panoramic view of Mukha Fall's beauty.</p> */}
           </div>
         </div>
   
         <BookSection />
       </div>
     );
};